import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import classes from './CollapsibleButtons.scss';

export default class CollapsibleButtons extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.any,
      content: PropTypes.node.isRequired,
    })).isRequired,
    selectedOption: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    wrapperClassName: PropTypes.string,
    buttonClassName: PropTypes.string,
  };

  static defaultProps = {
    selectedOption: null,
    wrapperClassName: undefined,
    buttonClassName: undefined,
  };

  state = {
    showAllOptions: false, // This is used for displaying all of the options in mobile mode
  };

  handleClick = optionId => () => {
    const { showAllOptions } = this.state;
    const { onSelect } = this.props;

    if (window.innerWidth >= 992 || showAllOptions) {
      this.setState({ showAllOptions: false });
      onSelect(optionId);
    } else {
      this.setState({ showAllOptions: true });
    }
  }

  renderArrow() {
    const { showAllOptions } = this.state;
    const classNames = [
      'icon',
      `icon-${showAllOptions ? 'collapse' : 'expand'}`,
      'd-inline d-sm-inline d-md-inliine d-lg-none',
      classes.mobileCaret,
    ];

    return <span className={classNames.join(' ')} />;
  }

  renderOption = ({ id, content }, index) => {
    const { showAllOptions } = this.state;
    const { selectedOption, wrapperClassName, buttonClassName } = this.props;

    const isSelected = selectedOption === id;
    let hideOnMobile = !showAllOptions;

    const wrapperClassNames = [classes.optionButtonWrapper];
    const classNames = [classes.optionButton];
    if (isSelected) {
      classNames.push('selected');
      hideOnMobile = false;
    }

    if (hideOnMobile) {
      wrapperClassNames.push('d-none d-sm-none d-md-none d-lg-block');
    }

    if (wrapperClassName) {
      wrapperClassNames.push(wrapperClassName);
    }
    if (buttonClassName) {
      classNames.push(buttonClassName);
    }

    const showArrow = (isSelected && !showAllOptions)
      || (index === 0 && showAllOptions);

    return (
      <div
        key={id}
        className={wrapperClassNames.join(' ')}
      >
        <Button
          className={classNames.join(' ')}
          block
          onClick={this.handleClick(id)}
        >
          {content}
          {showArrow ? this.renderArrow() : false}
        </Button>
      </div>
    );
  };

  render() {
    const { options } = this.props;

    return (
      <div className={classes.optionButtons}>
        {options.map(this.renderOption)}
      </div>
    );
  }
}
